/* eslint-disable */
import React, { memo, RefObject, useRef, useState } from "react";
import styles from "./VideoPageBar.module.css";
import { Popper } from "@material-ui/core";
import { VideoPDF, VideoSlide } from "../../../../../common/video/models/Video";
import { Document, Page, pdfjs } from "react-pdf";

interface VideoPageBarProps {
  pdf: VideoPDF;
  videoSlides: VideoSlide[];
  videoDuration: number;
  currentVideoTimeMs: number;
  videoRef: RefObject<HTMLVideoElement>;
}

function VideoPageBar({
  pdf,
  videoSlides,
  videoDuration,
  currentVideoTimeMs,
  videoRef,
}: VideoPageBarProps) {
  const refObject = useRef<HTMLDivElement>(null);
  const width = refObject.current?.getBoundingClientRect().width || 0;

  return (
    <div className={styles.sildeTimelineWrapper} ref={refObject}>
      {/* {pdf.videoSlides.map((item, index) => ( */}
      {videoSlides.map(
        (item, index) =>
          (index === 0 || item.startMillis >= 0) && (
            <PageBar
              key={index}
              slide={item}
              url={pdf.slideUrl}
              pageNum={index + 1}
              endMillis={
                videoSlides.length === index + 1
                  ? videoDuration
                  : videoSlides[index + 1].startMillis >= 0
                  ? videoSlides[index + 1].startMillis
                  : videoDuration
              }
              width={width - 32}
              videoDuration={videoDuration}
              currentVideoTimeMs={currentVideoTimeMs}
              videoRef={videoRef}
            />
          )
      )}
    </div>
  );
}

interface PageBarProps {
  slide: VideoSlide;
  url: string;
  pageNum: number;
  endMillis: number;
  width: number;
  videoDuration: number;
  currentVideoTimeMs: number;
  videoRef: RefObject<HTMLVideoElement>;
}

function PageBar({
  slide,
  url,
  pageNum,
  endMillis,
  width,
  videoDuration,
  currentVideoTimeMs,
  videoRef,
}: PageBarProps) {
  const lineWidth =
    endMillis === videoDuration
      ? ((endMillis - slide.startMillis) / videoDuration) * width - 3
      : ((endMillis - slide.startMillis) / videoDuration) * width;

  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const clickHandler = () => {
    if (videoRef && videoRef.current) {
      videoRef.current.currentTime = slide.startMillis / 1000;
    }
  };

  const handleHover = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  return (
    <>
      <div
        className={
          Math.floor(currentVideoTimeMs / 1000) >=
            Math.floor(slide.startMillis / 1000) &&
          currentVideoTimeMs < Math.floor(endMillis / 1000) * 1000
            ? styles.slideTimelineCurrent
            : styles.slideTimeline
        }
        style={{
          width: `${lineWidth}px`,
          marginRight: endMillis === videoDuration ? "0px" : "3px",
        }}
        onClick={clickHandler}
        onMouseOver={handleHover}
        onMouseOut={handleClose}
      />

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement={"bottom-start"}
        style={{ zIndex: 100 }}
        transition
      >
        <div className={styles.slideDiv}>
          <Document
            file={url}
            options={{
              cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
              cMapPacked: true,
            }}
          >
            <Page pageNumber={pageNum} className={styles.slideImg} />
          </Document>
        </div>
      </Popper>
    </>
  );
}

export default memo(VideoPageBar);
